import { Component, Input, OnInit, ChangeDetectorRef } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-mount-usb-confirm",
  templateUrl: "./mount-usb-confirm.component.html",
})
export class MountUsbConfirmComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() needDoubleConfirm: boolean = false;
  doubleConfirm = false;

  constructor(
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {    
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.close(null);
  }
}
